import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 px-4 md:px-6 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20shopping%20scene%20with%20carefully%20wrapped%20packages%20and%20shopping%20bags%20on%20light%20wooden%20floor%2C%20soft%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20peaceful%20lifestyle%20photography%2C%20warm%20and%20inviting%20atmosphere&width=1800&height=900&seq=cta-bg-v2&orientation=landscape"
          alt="Superbuy Spreadsheet shopping experience"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/60 to-background-50/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100/70 rounded-full mb-5 tracking-wide">
          Start Shopping Smarter
        </span>
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-5 leading-tight">
          Ready To Transform Your<br />Shopping Experience?
        </h2>
        <p className="text-base md:text-lg text-foreground-600 mb-10 max-w-xl mx-auto">
          Access the complete Superbuy Spreadsheet resource and start discovering products
          faster with organized categories and expert guides.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-8 py-3.5 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
            Access Superbuy Spreadsheet
            <i className="ri-arrow-right-up-line ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <Link
            to="/what-is-superbuy-spreadsheet"
            className="px-8 py-3.5 text-sm font-semibold text-foreground-700 border border-foreground-300 rounded-full hover:bg-background-50/80 transition-all whitespace-nowrap cursor-pointer"
          >
            Read The Complete Guide
          </Link>
        </div>
      </div>
    </section>
  );
}